import { cva } from 'class-variance-authority';

export { default as BaseTile } from './BaseTile.vue';
export * from './BaseTile.vue';

export const baseTileVariants = cva(
  'c-tile',
  {
    variants: {
      variant: {
        default: 'c-tile--left',
        center: 'c-tile--center',
        imageLeft: 'c-tile--image-left',
        header: 'c-tile--header',
      },
      limitLines: {
        true: 'c-tile--limit-lines',
      },
      asLink: {
        true: 'c-tile--as-link',
      },
      size: {
        medium: 'c-tile--medium',
        large: 'c-tile--large',
        stretch: 'c-tile--stretch',
        media: 'c-tile--media',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'medium',
      limitLines: false,
      asLink: true,
    },
  },
);
